import { render, staticRenderFns } from "./COD-Detail.vue?vue&type=template&id=3d1553e0&scoped=true"
import script from "./COD-Detail.vue?vue&type=script&lang=js"
export * from "./COD-Detail.vue?vue&type=script&lang=js"
import style0 from "./COD-Detail.vue?vue&type=style&index=0&id=3d1553e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1553e0",
  null
  
)

export default component.exports